/*
 * Registers the Jobs page and its sidebar link. The directory and route stay `backups`; only
 * the label changed (#349), so links and bookmarks keep working.
 *
 * Its own page rather than a section of Agents, because the question it answers is about
 * applications and not machines: "is anything wrong with my backups" is asked by someone who does
 * not know, or care, which agent runs them.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const BACKUPS_PATH = '/backups';

const backupsPage = PageBlueprint.make({
  name: 'stackschematic-backups',
  params: {
    path: BACKUPS_PATH,
    loader: async () => {
      const { BackupsPage } = await import('./BackupsPage');
      return <BackupsPage />;
    },
  },
});

export const stackSchematicBackupsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [backupsPage],
});
